export default __webpack_public_path__ + "locales/uk-UA/Settings.json?hash=7595d4156cdad9a98486c450b5ef7f90";